export const PREFERRED_MORE_METHODS_CTA_TEXT = "+ {0} more payment methods";
export const PREFERRED_ONE_MORE_METHOD_CTA_TEXT = "+ {0} more payment method";
export const PREFERRED_DEFAULT_FOLD_SIZE = 3;
